import { API_URL } from "env";

interface Product {
    id: number;
    name: string;
    slug: string;
    product_category_id: number;
    price: number;
    discount: number;
    avatar: string;
    is_active: number;
    is_highlight: number;
    short_content: string;
    list_thumbnail: string;
    position: number;
    translation: string;
    star: number;
    is_stock: number;
    ingredients: string;
    indications: string;
    contraindications: string;
    dosage: string;
    drug_interactions: string;
    storage: string;
    overdose: string;
    is_limit: number;
    is_new: number;
    is_follow: number;
    alt: string;
}

export interface PromotionProduct {
    promotion_flash_sale_id: number;
    product_id: number;
    percent: number;
    product: Product;
}

export interface FlashSaleItem {
    id: number;
    name: string;
    slug: string;
    describe: string;
    avatar: string;
    start_time: string;
    end_time: string;
    created_at: string;
    updated_at: string;
    promotion_flash_sale_product: PromotionProduct[];
}

export interface ListPromotion {
    status: boolean;
    data: {
        total: number;
        current_page: number;
        items: FlashSaleItem[];
    };
    msg: string;
}

async function fetchFlashSales(page: number, limit: number): Promise<ListPromotion> {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No authentication token found');
        }
        const query = new URLSearchParams();
        query.append('page', String(page));
        query.append('limit', String(limit));

        const response = await fetch(`${API_URL}/api/v1/fe/promotion_flash_sales?${query.toString()}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error fetching flash sales:", error);
        throw error;
    }
}
interface FlashSaleSlugResponse {
    status: boolean;
    data: FlashSaleItem | null;
    msg: string;
}

async function fetchSlugFlashSales(slug: string): Promise<FlashSaleSlugResponse> {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No authentication token found');
        }

        const response = await fetch(`${API_URL}/api/v1/fe/promotions/flash-sales/${slug}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data: FlashSaleSlugResponse = await response.json();
        return data;
    } catch (error) {
        console.error("Error fetching flash sale by slug:", error);
        throw error;
    }
}

export { fetchFlashSales, fetchSlugFlashSales };